(() => {
  const base = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
  async function add(items, status, controls, errorText) {
    controls.forEach(c => c.disabled = true);
    try {
      const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || errorText);
      window.location.assign(base + 'cart');
    } catch (error) {
      status.textContent = error.message || errorText;
      controls.forEach(c => c.disabled = false);
    }
  }
  function init() {
    document.querySelectorAll('[data-native-add]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit',event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const status = form.querySelector('[data-native-status]');
        add([{id:Number(form.elements.id.value),quantity:Number(form.elements.quantity.value)}],status,[...form.querySelectorAll('button,input')],document.querySelector('[data-native-messages]')?.dataset.error || 'Unable to add this item. Please review your cart.');
      });
    });
    document.querySelectorAll('[data-native-starters]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form'), lines = [...root.querySelectorAll('[data-variant]')], status = root.querySelector('[data-status]'), text = JSON.parse(root.querySelector('[data-starter-text]').textContent);
      const presets = {topicals:[6,6,4,0,0],balanced:[4,4,4,8,0],full:[4,4,4,4,4]};
      function update() {
        let total = 0, count = 0;
        for (const line of lines) {
          const qty = Number(line.querySelector('input').value), value = qty * Number(line.dataset.price);
          total += value; count += qty;
          line.querySelector('output').textContent = money(value);
        }
        root.querySelector('[data-total]').textContent = money(total);
        form.querySelector('[type=submit]').disabled = !count || !form.checkValidity();
        status.textContent = count ? '' : text.empty;
      }
      root.querySelectorAll('[data-preset]').forEach(button => button.addEventListener('click',() => {
        root.querySelectorAll('[data-preset]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        lines.forEach(line => line.querySelector('input').value = presets[button.dataset.preset][Number(line.dataset.index)]);
        update();
      }));
      form.addEventListener('input',() => {root.querySelectorAll('[data-preset]').forEach(b => b.setAttribute('aria-pressed','false'));update();});
      form.addEventListener('submit',event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const items = lines.map(line => ({id:Number(line.dataset.variant),quantity:Number(line.querySelector('input').value)})).filter(item => item.quantity > 0);
        if (!items.length) return;
        status.textContent = text.busy;
        add(items,status,[...root.querySelectorAll('button,input')],text.error);
      });
      update();
    });
  }
  document.addEventListener('shopify:section:load',init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
